import { render, staticRenderFns } from "./AddingNewNotes.vue?vue&type=template&id=23447975&scoped=true"
import script from "./AddingNewNotes.vue?vue&type=script&lang=js"
export * from "./AddingNewNotes.vue?vue&type=script&lang=js"
import style0 from "./AddingNewNotes.vue?vue&type=style&index=0&id=23447975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23447975",
  null
  
)

export default component.exports